import { createBrowserHistory } from 'history';
import { getToken } from '../../services/api/axiosDefaults';
import decode from 'jwt-decode';

const historyConfig = {
        basename: 'pnh'
    };

export const history = createBrowserHistory(historyConfig);

export const checkAuth = () => {
  // check token validation, if auth fails return false
  let token = getToken();

  if(!token){
    return false;
  }
  try{
    const { exp } = decode(token);
    if(exp < new Date().getTime() / 1000){
      return false;
    }
  }catch(e){
    return false;
  }
  return true;
}

// boat: process.env.OBJECT_TYPE_BOAT,
// woonboot: process.env.OBJECT_TYPE_WOONBOOT,
// steiger: process.env.OBJECT_TYPE_STEIGER
export const getObjectType = () => {
	const objectType = {
		boat: 'c2b23a5a-463d-e280-9311-c3a8cb86c3b9',
		woonboot: 'adc86df3-a6ef-11e9-8da0-e83935edaed6',
		steiger: '9de15dc3-a6ef-11e9-8da0-e83935edaed6'
	}
	return objectType;
}


export const computeSize = (formName, length, width, props) => {
  let product = 0;
  let cleanedLength = length.replace(',', '.')
  let cleanedWidth = width.replace(',', '.')
  product = cleanedLength * cleanedWidth;
  props.changeSizeField(formName, product.toFixed(2));
}

export const normalizeNumber = (value, previousValue) => {
  if (!value) {
    return value
  }

  let myExpression = new RegExp('^[0-9]+([,.])?([0-9]{1,2})?$');
  let numberPermitted = myExpression.test(value);

  if (numberPermitted) {
    return value;
  }
  return previousValue;
}

export const normalizeNonDecimal = (value) => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d*]/g, '');
  return onlyNums;
}

